export const SOURCES = {
  TYPE: {
    RAIL_INFRASTRUCTURE: 'ZEL_INFRASTUKTURA',
    HALLS: 'HALY',
    ROOMS: 'MISTNOSTI',
    OTHERS: 'OSTATNI',
  },
}
